// imove-branch: 当前是否为创建页

export default async function(ctx) {
     const { pathname = '', } = ctx.payload;
     console.log('1111','/create'.startsWith(pathname));
    if('/create'.startsWith(pathname))return true;
  return false;
}